module.exports = __webpack_public_path__ + "static/img/frame.543b77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate/frame.png
// module id = WTjZ
// module chunks = 1